import React from 'react'

// hoc
import withGlotio from 'hoc/withGlotio';
import DefinitionBlock, { FieldsByDefinition } from '../DefinitionBlock'

// styles
import styles from './index.module.scss';

const DefinitionsBlocks = props => {
  const {
    definitions,
    handleCheckboxChange,
    translateText,
    formatNumber,
    getDisabledFields
  } = props
  const hasWithTitle = definitions.withTitle && definitions.withTitle.length > 0
  const hasWithOutTitle = definitions.withOutTitle && definitions.withOutTitle.length > 0
  const hasOnlyWithTitle = hasWithTitle && !hasWithOutTitle && !definitions.title
  const itemsClassName = hasOnlyWithTitle ? '' : styles.definition_module_items

  return (
    <div className={styles.definition_module_container}>
      {
        definitions.title &&
        <span className={styles.definition_title}>{definitions.title}</span>
      }
      <div className={itemsClassName}>
        {
          hasWithOutTitle &&
          <div className={styles.definition_wrapper}>
            {
          definitions.withOutTitle.map(definition => {
              const { _id: id } = definition
              return (
                <FieldsByDefinition
                  key={id}
                  value={id}
                  definition={definition}
                  translateText={translateText}
                  disabledFields={getDisabledFields(id)}
                  handleCheckboxChange={handleCheckboxChange}
                  formatNumber={formatNumber}
                />
              )
            })
            }
          </div>
      }
        {
        hasWithTitle &&
          <div className={styles.definition_module_with_title_container}>
            {
              definitions.withTitle.map(definition => {
                const { _id: id } = definition
                return (
                  <DefinitionBlock
                    key={id}
                    value={id}
                    definition={definition}
                    translateText={translateText}
                    formatNumber={formatNumber}
                    disabledFields={getDisabledFields(id)}
                    handleCheckboxChange={handleCheckboxChange}
                    extraMargin={hasOnlyWithTitle}
                  />
                )
              })
            }
          </div>
      }
      </div>
    </div>
  )

}

export default withGlotio(DefinitionsBlocks)
